import styled, { css } from 'styled-components';

export const TabsContainer = styled.div<{ isMobile?: boolean }>`
  display: flex;
  width: 100%;
  gap: 16px;
  padding: 0 32px;
  height: 100%;
  align-items: center;
  position: relative;
  justify-content: center;

  ${({ isMobile }) =>
    isMobile &&
    css`
      justify-content: center;
      border-bottom: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
    `}
`;

export const TabItem = styled.div<{ isSelected?: boolean; isMobile?: boolean }>`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;

  ${({ isMobile }) =>
    isMobile
      ? css`
          font-size: 14px;
          line-height: 24px;
        `
      : css`
          height: unset;
          margin-top: 24px;
          padding-bottom: 16px;
        `};

  ${({ isSelected }) =>
    isSelected &&
    css`
      font-weight: 700;
      color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};

      &:after {
        content: '';
        display: block;
        position: absolute;
        top: unset;
        bottom: 0;
        height: 2px;
        left: 0;
        right: 0;
        background: ${({ theme }) => theme.kallisto.color.border.interactive.borderPrimaryDefault};
      }
    `};
`;
